export default __webpack_public_path__ + "static/media/default.28731342.svg";